import { HeadCell } from '../../../types/grid';
import { PATH_DASHBOARD } from '../../../app';
import { Link } from '../../../types';

export const CONTACT_MESSAGES_HEAD_LIST: readonly HeadCell[] = [
  { id: 'id', label: 'ID' },
  { id: 'contactPersonName', label: 'Name' },
  { id: 'companyName', label: 'Company' },
  { id: 'location', label: 'Location' },
  { id: 'phoneNumber', label: 'Phone Number' },
  { id: 'email', label: 'Email' },
  { id: 'websiteUrl', label: 'Web Site' },
  { id: 'attachments', label: 'Attachments' },
  { id: 'createdAt', label: 'Created At' },
  { id: 'more_menu', label: '' },
] as const;

export const LINKS: Link[] = [
  { name: 'Dashboard', href: PATH_DASHBOARD.root },
  { name: 'List' },
];
